var recaptchavalidation = {
    recaptchaKey: null,
    LoadGoogleReCaptcha: async function () {
        recaptchaKey = await this.GetRecaptchKey();
        if (recaptchaKey) {
            var src = "https://www.google.com/recaptcha/enterprise.js?render=" + recaptchaKey;
            var script = document.createElement("script");
            script.type = 'text/javascript';
            script.async = true;
            script.defer = true;
            script.setAttribute("src", src);
            document.querySelector("body").appendChild(script);
        }
    },
    IsValid: async function () {
        if (grecaptcha) {
            return new Promise((resolve, reject) => {
                grecaptcha.enterprise.ready(async function () {
                    if (recaptchaKey) {
                        grecaptcha.enterprise.execute(recaptchaKey, { action: 'submit' }).then(async function (token) {
                            document.getElementById('g-recaptcha-response').value = token;
                            const isValid = await recaptchavalidation.IsRecaptchaValid(token);
                            if (isValid) {
                                resolve(true);
                            } else {
                                resolve(false);
                            }
                        }).catch((error) => {
                            console.error('reCAPTCHA execution error:', error);
                            resolve(false);
                        });
                    } else {
                        console.error('ReCAPTCHA key is not defined.');
                        resolve(false);
                    }
                });

            });

        } else {
            return true;
        }
    },
    GetRecaptchKey: async function () {
        const url = new URL('/Recaptcha/GetReCaptchaKey', window.location.origin);

        try {
            const response = await fetch(url, {
                method: 'GET'
            });

            if (!response.ok) {
                console.log('Response status: ' + response.status + '');
                return null;
            }
            const data = await response.json();
            return data.recaptchaKey;
        } catch (error) {
            console.error('An error occurred while validating the reCAPTCHA.:', error);
            return null;
        }
    },
    IsRecaptchaValid: async function (token) {
        const url = new URL('/Recaptcha/SubmitForm', window.location.origin);

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ recaptchaToken: token })
            });
            const data = await response.json();

            if (!response.ok) {
                console.log('Response status: ' + response.status + '');
                alert('reCAPTCHA validation failed.');
                return false;
            }

            if (!data.success) {
                if (data.message && data.message.length > 0) {
                    alert(data.message);
                } else {
                    alert('reCAPTCHA validation failed.');
                }
            }

            return data.success;
        } catch (error) {
            console.error('An error occurred while validating the reCAPTCHA: ', error);
            return false;
        }
    }
}

recaptchavalidation.LoadGoogleReCaptcha();